import axios from "axios";

const axiosCustom = axios.create();

axiosCustom.interceptors.request.use(
  function (config) {
    config.headers["Authorization"] = process.env.VUE_APP_API_TOKEN;
    if (!config.data) {
      config.data = {};
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
axiosCustom.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);
function initRequest() {
  axiosCustom.defaults.timeout = 30000;
  axiosCustom.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;
  axiosCustom.defaults.data = {};
}

function request(config) {
  return axiosCustom.request(config);
}

export { request, initRequest };
